import { render, staticRenderFns } from "./UserTechnicians.vue?vue&type=template&id=ccf329ba&scoped=true"
import script from "./UserTechnicians.vue?vue&type=script&lang=js"
export * from "./UserTechnicians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf329ba",
  null
  
)

export default component.exports